/* eslint-disable */
import React from 'react';

function WithdrawIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6 0H14.4C16.38 0 18 1.62 18 3.6C18 5.13 17.1 6.39 15.75 6.93V3.6C15.75 3.24 15.57 2.88 15.39 2.61C15.21 2.34 14.76 2.25 14.4 2.25H3.6C3.24 2.25 2.88 2.43 2.61 2.61C2.34 2.79 2.25 3.24 2.25 3.6V6.93C0.9 6.39 0 5.13 0 3.6C0 1.62 1.62 0 3.6 0Z"
        fill="#8029EF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4 3.6001V14.4001C14.4 15.3901 13.59 16.2001 12.6 16.2001H5.4C4.41 16.2001 3.6 15.3901 3.6 14.4001V3.6001H14.4ZM7.65 10.3501L8.28 10.9801V7.2001C8.28 6.8401 8.55 6.4801 9 6.4801C9.45 6.4801 9.72 6.7501 9.72 7.2001V10.9801L10.35 10.3501C10.62 10.0801 11.07 10.0801 11.34 10.3501C11.61 10.6201 11.61 11.0701 11.34 11.3401L10.17 12.5101C9.54 13.1401 8.55 13.1401 7.92 12.5101L6.75 11.3401C6.48 11.0701 6.48 10.6201 6.75 10.3501C7.02 10.0801 7.38 10.0801 7.65 10.3501Z"
        fill="#8029EF"
      />
    </svg>
  );
}

WithdrawIcon.propTypes = {};

export default WithdrawIcon;
